import { useLocation } from "react-router-dom";
import SEOHead from "@/components/feature/SEOHead";
import FloatingButton from "@/components/feature/FloatingButton";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 py-16">
      <SEOHead
        title="Page introuvable | Dépan'Volets Strasbourg"
        description="Cette page n'existe pas sur le site Dépan'Volets Strasbourg. Retournez à l'accueil pour découvrir nos services de réparation et motorisation de volet roulant."
        robots="noindex, nofollow"
        path={location.pathname}
      />
      <div className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-[#E5EBF0] select-none pointer-events-none z-0">
        404
      </div>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-[#143A66]">Page introuvable</h1>
        <p className="mt-2 text-base text-[#143A66]/60 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-[#143A66]/70">Cette page n'existe pas sur notre site.</p>
        <div className="mt-6 p-4 bg-[#143A66]/5 rounded-xl border border-[#143A66]/10 max-w-sm mx-auto">
          <p className="text-sm text-[#143A66]/80 mb-1">Un volet bloqué ? Appelez-nous directement</p>
          <a
            href="tel:0374473240"
            className="inline-block text-[#143A66] font-bold text-lg md:text-xl hover:text-[#00B3A4] transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            03 74 47 32 40
          </a>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-4">
          <a
            href="/"
            className="px-6 py-3 bg-[#00B3A4] text-white rounded-full font-semibold text-base hover:bg-[#00B3A4]/90 transition-all duration-200 btn-hover-effect whitespace-nowrap"
          >
            Retour à l'accueil
          </a>
          <a
            href="/contact"
            className="px-6 py-3 border-2 border-[#00B3A4] text-[#00B3A4] rounded-full font-semibold text-base hover:bg-[#00B3A4]/10 transition-all duration-200 btn-hover-effect whitespace-nowrap"
          >
            Nous contacter
          </a>
        </div>
      </div>
      <DiagnosticVideo />
      <FloatingButton />
    </div>
  );
}